import { Box, Button, Image, Stack, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { MdWatchLater } from 'react-icons/md';

const ChartIdeasDetails = ({id,name,date_time,time,flag,flag2,cover,description}) => {


    return (
        <VStack w={"100%"} h="100%" justifyContent="center" alignItems="center">
            <Stack  flexWrap="wrap" justifyContent="center" alignItems="center" flexDir="row" gap="0" w="80%" h="100%" bg="#601FEB" borderRadius="32px">
                  <Box
                    key={id}
                    w={ "100%" }
                    bg="transparent"
                    p="15px"
                  >
                    <Box
                      w="100%"
                      display="flex"
                      borderRadius="32px"
                      alignItems=""
                      p="20px"
                      flexWrap="wrap"
                      transition="0.3s"
                    >
                      {/* topbar */}
                      <Stack w="100%" flexDir="row" py="10px">
                        <Box display="flex" w="60%">
                          <Image src={flag} w="47px" h="30px" />
                          <Image src={flag2} w="47px" h="30px" mx="15px" />
                        </Box>
                        <Box w="40%">
                          <Text
                            fontFamily="'Roboto', sans-serif"
                            fontSize="18px"
                            fontWeight="600"
                            color="#fff"
                            textAlign="end"
                          >
                            {name}
                          </Text>
                        </Box>
                      </Stack>
                      <Stack w="100%" flexDir="row" pb="10px">
                        <Box
                          display="flex"
                          justifyContent="flex-start"
                          alignItems="center"
                          w="50%"
                        >
                          <Text
                            fontFamily="'Poppins', sans-serif"
                            fontSize="14px"
                            fontWeight="600"
                            color="#fff"
                          >
                            April 02. 2023
                          </Text>
                        </Box>
                        <Box
                          w="50%"
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center"
                        >
                          <MdWatchLater
                            style={{ fontSize: "20px", color:"#fff"}}
                            
                          />
                          <Text
                            fontFamily="'Poppins', sans-serif"
                            fontSize="16px"
                            fontWeight="600"
                            color="#fff"
                          >
                            {name}
                          </Text>
                        </Box>
                      </Stack>

                      <Stack position="relative" w="100%" pt="20px">
                        <Image
                          src={cover}
                          w="100%"
                          h="194px"
                          borderRadius="25px"
                        />
                      </Stack>
                      <Box py="25px">
                      <Text
                            fontFamily="'Poppins', sans-serif"
                            fontSize="16px"
                            fontWeight="600"
                            color="#fff"
                            pb="15px"
                          >
                            Description :
                             <br />
                          </Text>
                      <Text
                            fontFamily="'Poppins', sans-serif"
                            fontSize="14px"
                            fontWeight="600"
                            color="#fff"
                          >

                            {description}
                          </Text>
                      </Box>

                      <Stack flexDir="row" justifyContent="space-between" w="100%">
                        <Button color="#B0B0B0" bg="transparent" _hover={{bg:'transparent'}}>Preview</Button>
                        <Button color="#fff" bg="transparent" _hover={{bg:'transparent'}}>Next</Button>
                      </Stack>
                    </Box>
                  </Box>
            </Stack>
        </VStack>
    );
};

export default ChartIdeasDetails;